var theme = {
    hover: {
        opacity: 0.64,
    },
    border: {
        radiusBig: "12px",
        radius: "8px",
        radiusSmall: "4px",
        width: "1px",
        style: "solid",
    },
    header: {
        height: 72,
    },
    footer: {
        desktop: {
            height: 52,
        },
        mobile: {
            height: 104,
        },
    },
};
export default theme;
//# sourceMappingURL=theme.js.map